import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcEdit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.697 3.533a1.75 1.75 0 0 0-2.474 0L4.74 15.016a2.75 2.75 0 0 0-.717 1.253l-.98 3.772a.75.75 0 0 0 .914.914l3.772-.98a2.75 2.75 0 0 0 1.253-.717l9.11-9.11.028-.028 2.344-2.344a1.75 1.75 0 0 0 0-2.475zm-4.065 3.713 2.121 2.121-8.83 8.83a1.25 1.25 0 0 1-.57.327l-2.537.659.66-2.537a1.25 1.25 0 0 1 .325-.57z",
    clipRule: "evenodd"
  }));
}
var IcEdit = createNolIcon(/*#__PURE__*/forwardRef(SvgIcEdit));

export { IcEdit as I };
